<template>
  <div class="default-path">
    <!-- 顶部自定义学习路线栏 -->
    <div class="custom-header-bar">
      <div class="header-left">
        <img class="header-icon" src="@/assets/book.png" alt="" />
        <span class="header-title">自定义课程文件夹</span>
      </div>
      <button class="edit-btn" :class="{ active: isEditMode }" @click="toggleEditMode">
        {{ isEditMode ? '退出编辑' : '编辑课程路线' }}
      </button>
    </div>

    <!-- 面包屑路径：只显示"全部" -->
    <div class="pickFileList">
      <div class="item current" @click="goToDefault">全部</div>
    </div>

    <!-- 文件夹 + 课程列表 -->
    <div v-if="sublist.length > 0 || list.length > 0" class="course-list">
      <!-- 文件夹（双击进入） -->
      <div class="file_item" v-for="item in sublist" :key="'key' + item.id" @dblclick="openfile(item)">
        <div class="img">
          <img src="@/assets/file.png" alt="" />
        </div>
        {{ item.name }}
      </div>
      <!-- 课程卡片 -->
      <div class="course-card" v-for="(item, index) in list" :key="'card' + index" @click="goDetail(item.news_id)">
        <div class="course-cover">
          <img :src="item.cover" alt="" />
        </div>
        <div class="course-info">
          <h4>{{ item.name }}</h4>
          <div class="course-footer">
            <span class="meta-study">{{ item.see_num }}人已学</span>
            <!-- 编辑模式下显示移出按钮 -->
            <button v-if="isEditMode" class="remove-btn" @click.stop="handleRemoveCourse(item)">
              <img src="@/assets/LIST_ADD.png" alt="">
              移出课程路线
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- 无数据状态 -->
    <div v-else class="empty-state">
      <img class="empty-image" src="@/assets/empty-data.png" alt="暂无数据" />
      <p class="empty-text">暂无课程数据</p>
    </div>

    <!-- ===== 多弹窗：使用 MinDialog（和 home 一样） ===== -->
    <min-dialog v-for="dialog in dialogs" :key="'dialog-' + dialog.id" :visible.sync="dialog.visible"
      :title="dialog.title" width="70%" :minimize-index="getMinimizeIndex(dialog.id)" :dialog-id="dialog.id"
      @close="removeDialog(dialog.id)" @minimize="onMinimize" @restore="onRestore">
      <iframe :src="dialog.url" frameborder="0" allowfullscreen style="width:100%; height:100%; border:none;"></iframe>
    </min-dialog>

    <!-- 已结束直播：video 播放器（保留原有逻辑） -->
    <div v-if="showPlayer && liveStatus === 2" class="video-container">
      <div class="video-header">
        <h3>{{ currentLiveTitle }}</h3>
        <button class="close-btn" @click="closePlayer">× 关闭</button>
      </div>
      <video class="live-video" controls controlslist="nodownload noplaybackrate" disablePictureInPicture autoplay
        :src="currentVideoUrl"></video>
    </div>
  </div>
</template>

<script>
import { collectList, collectDel, newsInfo, livesInfo } from '@/api/api'
import MinDialog from '@/components/MinDialog.vue'

export default {
  name: "index",
  components: {
    MinDialog
  },
  data() {
    return {
      // 当前目录下的课程
      list: [],
      // 当前目录下的子文件夹
      sublist: [],
      // 面包屑路径（从根到当前依次进入过的分类）
      pickFileList: [],
      // 课程分类树：id -> 节点
      categoryMap: {},
      // 一级分类（根目录下的文件夹）
      rootCategories: [],
      // 无 cateinfo 的课程（兜底显示在根目录）
      orphanCourses: [],
      // 当前所在分类 id，0 表示根目录
      cateids: 0,
      // 全部课程缓存（用于重建树）
      allList: [],
      // 收藏夹 id
      id: '',
      // 编辑模式状态
      isEditMode: false,
      // ===== 视频/直播相关（保留原有逻辑） =====
      showPlayer: false,
      liveStatus: 0,
      currentLiveUrl: '',
      currentVideoUrl: '',
      currentLiveTitle: '',
      // ===== 多弹窗管理（和 home 一样） =====
      dialogs: [],
      dialogId: 0,
      minimizeStates: {},
      loadingDialogs: new Set(),
      // 默认视图：所有第三层节点的子节点（第四层文件夹）
      defaultSublist: [],
      defaultList: [],
    }
  },
  watch: {
    '$route'(to, from) {
      this.isEditMode = false
      this.id = to.query.id
      this.cateids = 0
      this.pickFileList = []
      this.collectList()
    }
  },
  mounted() {
    this.id = this.$route.query.id
    this.collectList()
  },
  methods: {
    generateRandomString(length = 32, charset = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789') {
      // 1. 获取当前时间戳（毫秒级）
      const timestamp = Date.now().toString();

      // 2. 生成随机数字和字符串（补充材料）
      const randomPart1 = Math.random().toString(36).substring(2, 10); // 随机字母数字
      const randomPart2 = Math.random().toString(10).substring(2, 8); // 纯随机数字
      const randomPart3 = String.fromCharCode(
        65 + Math.floor(Math.random() * 26),
        97 + Math.floor(Math.random() * 26),
        48 + Math.floor(Math.random() * 10)
      ); // 随机大小写字母 + 数字各一个

      // 3. 合并所有素材
      let combined = timestamp + randomPart1 + randomPart2 + randomPart3;

      // 4. 如果合并后的长度不足目标长度，继续补充随机字符
      while (combined.length < length) {
        combined += Math.random().toString(36).substring(2, 10);
      }

      // 5. 截取所需长度
      combined = combined.substring(0, length);

      // 6. 打乱顺序（Fisher-Yates 洗牌算法）
      const arr = combined.split('');
      for (let i = arr.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [arr[i], arr[j]] = [arr[j], arr[i]];
      }

      // 7. 可选：使用自定义字符集过滤（如果传入自定义字符集）
      if (charset !== 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789') {
        // 如果自定义字符集，从结果中筛选可用字符，不足则补充
        let filtered = arr.filter(ch => charset.includes(ch)).join('');
        while (filtered.length < length) {
          const extra = generateRandomString(length - filtered.length, charset);
          filtered += extra;
        }
        return filtered.substring(0, length);
      }

      return arr.join('');
    },
    // ===== 多弹窗管理（和 home 一样） =====
    // 打开课件弹窗
    goDetail(id) {
      // 检查是否已打开相同课件（用 newsId 判断）
      const existing = this.dialogs.find(d => d.newsId === id)

      if (existing) {
        if (this.minimizeStates[existing.id]) {
          this.$set(existing, 'visible', false)
          this.$nextTick(() => {
            this.$set(existing, 'visible', true)
            this.$set(this.minimizeStates, existing.id, false)
          })
        } else if (!existing.visible) {
          this.$set(existing, 'visible', true)
        }
        return
      }

      if (this.loadingDialogs.has(id)) {
        return
      }

      this.loadingDialogs.add(id)

      newsInfo(id).then((res) => {
        let url = "";
        if (res.data.url) {
          if (res.data.url.startsWith("http")) {
            url = `https://ow365.cn/?i=37451&ssl=0&n=5&htool=1&draw=3&fname=${this.generateRandomString(10)}&furl=${encodeURIComponent(res.data.url)}`;
          } else {
            url = res.data.url;
          }
        }
        console.log('open6', url);

        this.dialogId++;
        const newId = this.dialogId;
        this.dialogs.push({
          id: newId,
          newsId: id,
          title: res.data.name || '未命名课件',
          url: url,
          visible: true
        });

        this.$set(this.minimizeStates, newId, false);
      }).catch(err => {
        console.error('获取课件信息失败:', err);
        this.$message.error('加载课件失败，请重试');
      }).finally(() => {
        this.loadingDialogs.delete(id)
      });
    },

    // 计算最小化弹窗的索引位置
    getMinimizeIndex(dialogId) {
      const minimizedIds = Object.keys(this.minimizeStates)
        .filter(id => {
          const dialog = this.dialogs.find(d => d.id == id)
          return this.minimizeStates[id] === true && dialog && dialog.visible
        })
        .map(Number)
        .sort((a, b) => a - b)

      const index = minimizedIds.indexOf(dialogId)
      return index >= 0 ? index : -1
    },

    onMinimize({ id, isMinimize }) {
      this.$set(this.minimizeStates, id, isMinimize)
    },

    onRestore({ id }) {
      this.$set(this.minimizeStates, id, false)
    },

    removeDialog(id) {
      this.dialogs = this.dialogs.filter(d => d.id !== id)
      this.$delete(this.minimizeStates, id)
    },

    // ===== 原有的直播播放逻辑（保留） =====
    handleLiveClick(id) {
      this.closePlayer()
      livesInfo(id).then((res) => {
        this.liveStatus = res.data.status
        if (res.data.status === 2) {
          this.currentVideoUrl = res.data.video_url
        } else {
          if (res.data.url.startsWith("https://") || res.data.url.startsWith("http://")) {
            this.currentLiveUrl = `https://ow365.cn/?i=37451&ssl=0&n=5&htool=1&draw=3&fname=${this.generateRandomString(10)}&furl=${res.data.url}`
          }
        }
        this.currentLiveTitle = res.data.name
        this.showPlayer = true
      })
    },

    closePlayer() {
      this.showPlayer = false
      this.currentLiveUrl = ""
      this.currentVideoUrl = ""
      this.currentLiveTitle = ""
      this.liveStatus = 0
    },

    // ===== 原有的 collectList 逻辑（不变） =====
    collectList() {
      let params = {
        page: 1,
        limit: 9999999,
        cate_id: this.id
      }
      collectList(params).then(res => {
        this.allList = res.data.list || []
        this.buildCategoryTree()
        this.buildDefaultView()
        this.goToDefault()
      })
    },

    buildDefaultView() {
      const fourthLevelNodes = []
      Object.values(this.categoryMap).forEach(node => {
        if (node.depth === 2 && node.children.length > 0) {
          node.children.forEach(child => {
            fourthLevelNodes.push(child)
          })
        }
      })
      this.defaultSublist = this.dedupe(fourthLevelNodes)
      this.defaultList = []
    },

    goToDefault() {
      this.cateids = 0
      this.pickFileList = []
      this.sublist = this.defaultSublist
      this.list = this.defaultList
    },

    buildCategoryTree() {
      this.categoryMap = {}
      this.rootCategories = []
      this.orphanCourses = []
      this.allList.forEach(course => {
        const info = course.cateinfo
        if (!info || !info.ids || !info.ids.length) {
          this.orphanCourses.push(course)
          return
        }
        info.ids.forEach((cid, i) => {
          if (!this.categoryMap[cid]) {
            this.categoryMap[cid] = {
              id: cid,
              name: info.names[i] || '',
              pid: i > 0 ? info.ids[i - 1] : 0,
              children: [],
              courses: [],
              depth: i
            }
          }
        })
        const leafId = info.ids[info.ids.length - 1]
        if (this.categoryMap[leafId]) {
          this.categoryMap[leafId].courses.push(course)
        }
      })
      Object.keys(this.categoryMap).forEach(k => {
        const node = this.categoryMap[k]
        if (node.pid === 0) {
          this.rootCategories.push(node)
        } else if (this.categoryMap[node.pid]) {
          this.categoryMap[node.pid].children.push(node)
        } else {
          this.rootCategories.push(node)
        }
      })
    },

    dedupe(list) {
      const seen = {}
      return list.filter(item => (seen[item.id] ? false : (seen[item.id] = true)))
    },

    renderFolder() {
      if (this.cateids === 0 || this.pickFileList.length === 0) {
        this.sublist = this.dedupe(this.rootCategories)
        let courses = []
        this.rootCategories.forEach(node => {
          courses = courses.concat(node.courses)
        })
        this.list = courses.concat(this.orphanCourses)
      } else {
        const current = this.categoryMap[this.cateids]
        this.sublist = current ? this.dedupe(current.children) : []
        this.list = current ? current.courses.slice() : []
      }
    },

    openfile(e) {
      this.pickFileList.push(e)
      this.cateids = e.id
      this.renderFolder()
    },

    pickHistory(e, index) {
      if (index < 0) {
        this.goToDefault()
      } else {
        let list = []
        for (let i = 0; i <= index; i++) {
          list.push(this.pickFileList[i])
        }
        this.pickFileList = list
        this.cateids = e.id
        this.renderFolder()
      }
    },

    toggleEditMode() {
      this.isEditMode = !this.isEditMode
    },

    handleRemoveCourse(course) {
      this.$confirm('您确定要移除课程吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        collectDel({ id: course.news_id, cate_id: this.id }).then(res => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
          this.collectList()
        })
      }).catch(() => { })
    }
  }
}
</script>

<style scoped lang="less">
/* 顶部栏样式 */
.custom-header-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  background-color: #fff9e6;
  padding: 16px 24px;
  border-radius: 8px;
  margin-bottom: 20px;
  box-sizing: border-box;

  .header-left {
    display: flex;
    align-items: center;
    gap: 12px;

    .header-icon {
      width: 48px;
      height: 48px;
      object-fit: contain;
    }

    .header-title {
      font-size: 20px;
      font-weight: 600;
      color: #1e293b;
    }
  }

  .edit-btn {
    background-color: #ff9f1c;
    color: #fff;
    border: none;
    border-radius: 8px;
    padding: 12px 32px;
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
      background-color: #e68a00;
    }

    &.active {
      background-color: #3355ff;

      &:hover {
        background-color: #2948e0;
      }
    }
  }
}

.pickFileList {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 20px;

  .item {
    font-size: 18px;
    cursor: pointer;
    font-weight: bold;
    color: #1e293b;

    &::after {
      content: ">";
      color: #333 !important;
      display: inline-block;
      transform: scaleX(0.6);
      margin: 0 10px;
    }

    &:hover {
      color: #3a86f7;
    }

    &.current {
      color: #3a86f7;
    }
  }

  .item:last-child::after {
    content: "";
    margin: 0;
  }
}

.course-list {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  align-items: flex-start;

  .file_item {
    width: 160px;
    height: 160px;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    font-size: 13px;
    border: 1px solid #f1f1f1;
    border-radius: 8px;
    cursor: pointer;

    &:hover {
      background: #f4f7ff;
    }

    .img {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 160px;
      height: 120px;

      img {
        width: 80px;
        height: 80px;
      }
    }
  }

  .course-card {
    width: 360px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px;
    background-color: #fff;
    border-radius: 12px;
    border: 1px solid #f1f1f1;
    cursor: pointer;
    transition: box-shadow 0.2s ease;

    &:hover {
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    }

    .course-cover {
      width: 120px;
      height: 84px;
      border-radius: 8px;
      overflow: hidden;
      flex-shrink: 0;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    .course-info {
      flex: 1;
      min-width: 0;

      h4 {
        font-size: 14px;
        font-weight: 500;
        color: #1e293b;
        margin: 0 0 8px 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        text-align: left;
      }

      .course-footer {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .meta-study {
          font-size: 12px;
          color: #94a3b8;
        }

        .remove-btn {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 6px;
          padding: 6px 10px;
          font-size: 12px;
          color: #ffffff;
          font-weight: 500;
          background-color: #ff3366;
          border: none;
          border-radius: 8px;
          cursor: pointer;
          transition: all 0.2s ease;

          img {
            width: 16px;
            height: 16px;
          }

          &:hover {
            opacity: 0.9;
          }
        }
      }
    }
  }
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80px 20px;
  text-align: center;

  .empty-image {
    width: 200px;
    height: 200px;
    margin-bottom: 20px;
    object-fit: contain;
    opacity: 0.7;
  }

  .empty-text {
    font-size: 16px;
    color: #94a3b8;
    margin: 0;
  }
}

/* ===== 视频播放器（保留原有逻辑） ===== */
.video-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  background: #000;
}

.video-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  background: #2f54eb;
  color: #fff;
  height: 56px;
  flex-shrink: 0;
}

.live-video {
  flex: 1;
  border: none;
  height: 50%;
}

.close-btn {
  padding: 6px 12px;
  background: #fff;
  color: #2f54eb;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
</style>
